import '@babel/polyfill'
// The Vue build version to load with the `import` command
import Alert from './components/Alert'
import PageLoading from './components/PageLoading'
import PlayersTable from './components/PlayersTable'
import Players from './components/Players'

import SponsorenList from './components/SponsorenList'
import { ROOT_CLEAR_ERROR, ROOT_PAGE_LOADING } from './store/mutation-types'

import Vue from 'vue'
import vuetify from './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store'
import VueCurrencyFilter from 'vue-currency-filter'
// import './registerServiceWorker'

// ramdajs.com
const R = require('ramda')

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

Vue.component('my-alert', Alert)
Vue.component('page-loading', PageLoading)
Vue.component('players', Players)
Vue.component('players-table', PlayersTable)
Vue.component('sponsoren-list', SponsorenList)

Vue.config.productionTip = false

/**
 * check on every route changed
 * if the error is set or the rout require loggedin to be true
 */
router.beforeEach(async (to, from, next) => {
  store.commit(ROOT_CLEAR_ERROR)
  store.commit(ROOT_PAGE_LOADING, false)
  // do logout without special view
  let path = null
  if (to.path === '/logout' && from.path !== '/logout' && from.path !== '/') {
    // dispatch logout
    await store.dispatch('logout')
    window.sessionStorage.removeItem(process.env.VUE_APP_KMO_SESSION_NAME)
    window.sessionStorage.clear()
    path = '/'
  } else if (to.path === '/logout') {
    window.sessionStorage.removeItem(process.env.VUE_APP_KMO_SESSION_NAME)
    window.sessionStorage.clear()
    path = '/'
  } else if (store.state.loggedIn && store.state.init && to.path !== '/buero') {
    path = '/buero'
  } else if (to.matched.some(record => record.meta.requiresAuth) && store.state.loggedIn === false) {
    path = '/login'
  }

  if (path !== null) {
    next({ path: path })
  } else {
    // make sure to always call next()!
    next()
  }
})

Vue.filter('sortByPosition', R.sortWith([
  R.ascend(R.prop('position')),
  R.ascend(R.prop('name'))
]))

// get the right damage color for circle or something else
Vue.filter('getStatusColor', function (value) {
  let color = 'success'
  if (value < 20) {
    color = 'error'
  }
  if (value >= 20 && value <= 49) {
    color = 'warning'
  }
  if (value > 49 && value < 90) {
    color = 'info'
  }
  return color
})

/**
 * return the colorstring for position or the position name
 * objct = {type:'color|string', position: 'A|M|S'}
 */
Vue.filter('positionColorString', function (position, type) {
  let colorString = ''
  let positionString = ''
  switch (position) {
    case 'A':
      // startspieler
      colorString = 'blue darken-3'
      positionString = 'Anfangs-Spieler'
      break
    case 'M':
      // mittelachse
      colorString = 'teal darken-3'
      positionString = 'Mitte-Spieler'
      break
    default:
      // schluss spieler
      colorString = 'brown darken-3'
      positionString = 'Schluss-Spieler'
      break
  }

  if (type === 'color') {
    return colorString
  }
  return positionString
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
